import { MLSListing } from '@aloft/toolkit-shared';

import { MLSDataColumn } from './MLSDataColumn.tsx';
import { MLSDataInfoSection } from './MLSDataInfoSection.tsx';
import { MLSDataValueWithLabel } from './MLSDataValueWithLabel.tsx';

export const MLSLocationInfo = ({ listingData }: { listingData: MLSListing }) => (
  <>
    <MLSDataInfoSection title="Location">
      <MLSDataColumn>
        <MLSDataValueWithLabel value={listingData.SubdivisionName} label="Subdivision" />
        <MLSDataValueWithLabel value={listingData.NeighborhoodName} label="Neighborhood" />
      </MLSDataColumn>
      <MLSDataColumn>
        <MLSDataValueWithLabel value={listingData.MLSAreaMajor} label="Area" />
        <MLSDataValueWithLabel value={listingData.CountyOrParish} label="County" />
      </MLSDataColumn>
    </MLSDataInfoSection>
    <MLSDataValueWithLabel leftAlign value={listingData.Directions} label="Directions" />
  </>
);
